export const EDIT_CONTACT = 'editContact'
